export default __webpack_public_path__ + "static/media/LogoAlta.c633809c.png";